import styled from "styled-components";


export const Container = styled.div`
display: flex;
flex-direction: column;
align-self: center;
`;

export const ExchangeDataContainer = styled.div`
display: flex;
margin: 0.5rem;
width: calc(100% - 7rem);
justify-content: space-around;
align-items: center;

div.exchange {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 500;
  width: 7rem;
  text-align: center;
  justify-content: center;
}
`;

/*
  props.status === success
    ? "#0DD07E"
    :
*/
export const DropdownButton = styled.select`
-moz-appearance: none;
-webkit-appearance: none;
padding: 0.5rem 1rem;
border: 0px;
outline-width: 0;
border-radius: 16px;
text-align-last: center;

background-color: ${(props: { status?: number }) =>
  props.status === 0
    ? "rgba(229, 37, 65, 0.8)"
    : props.status === 1
    ? "#FFD92E"
    : props.status === 2
    ? "#4779F4"
    : props.status === 3
    ? "#0dd07e"
    : "#CA33CD"};
color: #fff;
&::-ms-expand {
  display: none;
}

option {
  padding: 0.25rem;
  background-color: #fff;
  color: #123559;
}
`;

export const ModalContainer = styled.div`
display: flex;
flex-direction: column;
align-items: center;
padding: 0.5rem;

h1 {
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  margin: 0;
  margin-bottom: 1rem;
}
`;

export const ButtonContainer = styled.section`
display: flex;
justify-content: space-around;
margin-top: 0.5rem;
width: calc(100% - 7rem);
`;

export const ConfirmButton = styled.button`
background-color: #0dd07e;
color: #fff;
border-radius: 20px;
margin: 1rem 0rem;
border: 3px solid #0dd07e;
width: 10rem;
`;

export const CancelButton = styled.button`
background-color: #fff;
border-radius: 20px;
margin: 1rem 0rem;
padding: 0.5rem;
border: 3px solid #0dd07e;
width: 10rem;
`;